import { Stack, Typography } from "@mui/material";
import { MprcContainer, MprcTypography } from "components";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { PublicationPanelDto } from "generated/CoreApi_v1";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";

interface IProps {
  viewData: PublicationPanelDto[];
}

/**
 * Painel lateral "Em alta"
 * @param props
 */
export const PanelPublicationTrending: React.FC<IProps> = (props) => {

  const { viewData } = props;
  const { t } = useTranslation("knowledge");

  return viewData.length > 0
    ? (
      <>
        <MprcContainer margin="dense">
          <Typography variant="h3">{t("Feed.Panels.PublicationTrending.Title")}</Typography>
        </MprcContainer>

        <Stack direction="column" spacing={2}>
          {
            viewData.map((item) => {
              return (
                <Link key={item.publicationId} to={KnowledgePaths.PublicationViewerResolver(item.publicationId, item.publicationType, item.parentPublicationId)}>
                  <Stack direction="column" spacing={0.5}>
                    <MprcFeedTypography component="div" variant="classification">{item.channelName}</MprcFeedTypography>
                    <MprcTypography component="div" variant="h6" noWrapRows={2}>
                      {item.title}
                    </MprcTypography>
                  </Stack>
                </Link>
              );
            })
          }
        </Stack>
      </>
    )
    : null;
};
